import { css } from '@emotion/react'

const table = css`
  th {
    &:nth-of-type(2) {
      width: 25%;
    }
  }
  tbody,
  thead {
    tr {
      & > *:first-of-type {
        padding-left: 21px !important;
      }
      & > *:nth-of-type(3) {
        text-align: right;
        padding-right: 16px;
      }
      & > *:last-of-type {
        padding-right: 24px;
        text-align: right;
        span {
          justify-content: flex-end;
        }
      }
    }
  }

  tbody tr td {
    padding-top: 10px;
    padding-bottom: 10px;

    &:first-of-type {
      padding-right: 8px;
    }
  }
`

const empty = css`
  tbody tr > td:last-of-type {
    text-align: left;
    height: 60px;
  }
`

const controls = css`
  // Overwrite rowControlsStyles
  opacity: 1;
  visibility: visible;
  justify-content: flex-start;
  padding-right: 0;

  button {
    margin-left: 0 !important;
  }
`
const numberField = css`
  width: 99px;
  & > * {
    width: 100%;
  }
`

const priceCell = css`
  & > * {
    width: 100%;
    & > span {
      text-decoration: line-through;
    }
  }
`
const footer = css`
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;

  button {
    width: calc(50% - 4px);
  }

  button:last-of-type {
    width: 100%;
  }
`

export const styles = {
  table,
  empty,
  controls,
  numberField,
  priceCell,
  footer,
}
